





















































































import {
  ref,
  defineComponent,
  computed,
  onMounted,
  watch
} from "@vue/composition-api";
import { useActions, useGetters } from "vuex-composition-helpers";
import { useInputRules } from "@/ts/functions/composition/inputRules";
import ImageInput from "@c/molecules/media/ImageInput.vue";
import TagsInput from "@c/molecules/tag/TagsInput.vue";
import CaldateInput from "@c/molecules/input/CaldateInput.vue";
import BackButton from "@c/atoms/app/BackButton.vue";
import CudLayout from "@/vue/layouts/crud/CudLayout.vue";
import VisibilityInput from "@c/molecules/input/VisibilityInput.vue";
import EventModel from "@/ts/models/eventClass";
import CaldateModel from "@/ts/models/caldateClass";
import store from "@/ts/store";

export default defineComponent({
  name: "EventCreation",

  components: {
    ImageInput,
    TagsInput,
    CaldateInput,
    BackButton,
    CudLayout,
    VisibilityInput
  },

  setup(props, { root }) {
    const { lastRoute } = useGetters({ lastRoute: "app/lastRoute" } as any);

    const rules = useInputRules();

    const { SEND_EVENT_CREATION } = useActions({
      SEND_EVENT_CREATION: "event/SEND_EVENT_CREATION"
    } as any);

    var place_id = ref(root.$route.params.place_id);
    var form = ref(false);
    var loading = ref(false);
    var newEvent = ref(new EventModel({ place_id: place_id.value }));

    const createEvent = () => {
      if (!newEvent.value.caldates.length) {
        store.commit("app/setAlert", {
          type: "error",
          msg: root.$i18n.t("Please select at least 1 date for the event")
        });
      } else {
        loading.value = true;
        SEND_EVENT_CREATION(newEvent.value)
          .then(() => {
            loading.value = false;
            root.$router.push("/place/" + newEvent.value.place_id + "/events");
          })
          .catch(() => {
            loading.value = false;
          });
      }
    };
    const updateTags = (tags: any) => {
      newEvent.value.tags = tags;
    };

    return {
      form,
      rules,
      loading,
      newEvent,
      createEvent,
      lastRoute
    };
  }
});
